<template>
  <div class="container">
    <h1>¡Gracias por tu Reservación!</h1>
    <p>Hemos recibido tu solicitud. Por favor, revisa la bandeja de entrada de tu correo electrónico para más detalles.</p>
    <p>Si no encuentras el correo, revisa también la carpeta de spam.</p>
    <router-link to="/" class="btn">Exit</router-link>
    <img src="@/assets/LogoO.jpg" alt="Gracias" class="thank-you-image" />
  </div>
</template>

<script>
export default {
  name: "FinalView",
};
</script>

<style scoped>
.container {
  text-align: center;
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f2f2f2;
  position: relative; 
}
h1 {
  color: #4caf50;
  margin-bottom: 20px;
}
p {
  color: #333;
  margin: 10px 0;
}
.btn {
  text-decoration: none;
  color: white;
  background-color: #4caf50;
  padding: 10px 20px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  margin-top: 20px;
}
.btn:hover {
  background-color: #45a049;
}
.thank-you-image {
  position: absolute; 
  bottom: 20px; 
  left: 20px; 
  width: 200px; 
  height: auto; 
}
</style>
